import React from 'react';
import { ButtonToolbar, MenuItem, Panel, SplitButton } from 'react-bootstrap';

import '../../Assets/Ui/RequestCounter.css';
import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/DateRangePicker';

const UserCounter = (props) => {

    // const typeOptions = [
    //     { value: 'all', label: 'Tous' },
    //     { value: 'new', label: 'Nouveau Clients' },
    //     { value: 'old', label: 'Ancien Clients' },
    // ]

    const numberRequestOptions = [
        { value: 'all', label: 'Tous' },
        { value: 'no-request', label: 'Aucune requête' },
        { value: 'one-request', label: 'Une requête' },
        { value: 'many-request', label: 'Plusieurs requêtes' },
        { value: 'deleted', label: 'Utilisateur supprimé' },
        { value: 'locked', label: 'Utilisateur bloqué' },
        { value: 'isSignaled', label: 'Utilisateur signalé'}
    ];

    const countryOptions = [
        { value: 'all', label: 'Tous pays' },
        { value: 'FR', label: '🇫🇷 France' },
        { value: 'BE', label: '🇧🇪 Belgique' },
        { value: 'CH', label: '🇨🇭 Suisse' },
        { value: 'LU', label: '🇱🇺 Luxembourg' },
        { value: 'MA', label: '🇲🇦 Maroc' },
        { value: 'DZ', label: '🇩🇿 Algérie' },
        { value: 'TN', label: '🇹🇳 Tunisie' },
        { value: 'SN', label: '🇸🇳 Sénégal' },
        { value: 'CI', label: '🇨🇮 Côte d\'Ivoire' },
        // Israël and Espagne are DECLARED markets, not phone buckets — a patient
        // who declared Spain counts here even on a French number, and is excluded
        // from the France bucket so the per-country totals still sum to the whole.
        // See buildCountryPhoneFilter on the server, which owns the rule.
        { value: 'IL', label: '🇮🇱 Israël' },
        { value: 'ES', label: '🇪🇸 Espagne' },
        { value: 'US', label: '🇺🇸 USA / Canada' },
        { value: 'other', label: 'Autre' },
    ];

    // const handleSelectTypeOption = (e) => {
    //     props.setTypeOption(e);
    // }

    const handleSelectNumberRequest = (e) => {
        props.setNumberRequest(e);
    };

    const handleSelectCountry = (e) => {
        props.setCountry(e);
    };

    return (
        <Panel>
            <Panel.Heading>
                <h6>Compteur et filtre</h6>
            </Panel.Heading>
            <Panel.Body>
                <div className="counter">
                    <div className="filter-block">
                        <div className="filter-block-user">
                            <div>
                                <DateRangePicker locale="fr-FR" onChange={props.setDate} value={props.dateRange} maxDate={new Date()}/>
                            </div>

                            <div className="select-block">
                                <ButtonToolbar>
                                    <SplitButton
                                        id="option-list"
                                        rootCloseEvent="mousedown"
                                        title={props.numberRequest.label}
                                    >
                                        {
                                            numberRequestOptions.map((v, i) => (
                                                <MenuItem
                                                    eventKey={v}
                                                    active={v.value === props.numberRequest.value}
                                                    onSelect={v.value === props.numberRequest.value ? undefined : handleSelectNumberRequest}
                                                    key={`item-${i}`}
                                                >
                                                    {v.label}
                                                </MenuItem>
                                            ))
                                        }
                                    </SplitButton>
                                </ButtonToolbar>
                            </div>

                            <div className="select-block">
                                <ButtonToolbar>
                                    <SplitButton
                                        id="country-list"
                                        rootCloseEvent="mousedown"
                                        title={(props.country && props.country.label) || 'Tous pays'}
                                    >
                                        {
                                            countryOptions.map((v, i) => (
                                                <MenuItem
                                                    eventKey={v}
                                                    active={v.value === (props.country && props.country.value)}
                                                    onSelect={v.value === (props.country && props.country.value) ? undefined : handleSelectCountry}
                                                    key={`country-${i}`}
                                                >
                                                    {v.label}
                                                </MenuItem>
                                            ))
                                        }
                                    </SplitButton>
                                </ButtonToolbar>
                            </div>
                        </div>
                    </div>

                    <div className="nb-block">
                        <Panel>
                            <Panel.Heading>
                                <h3>Total</h3>
                                {props.loading ? (
                                    <span className="loader" />
                                ) : (
                                    <h2>{props.count}</h2>
                                )}
                            </Panel.Heading>
                        </Panel>
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
};

export default UserCounter;
